import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
import { EventsProvider, coEventsParameters } from '../../providers/events/events';
import { LocationsProvider } from '../../providers/locations/locations';
import { ConfigProvider } from '../../providers/config/config';
import { NavController, Platform, ModalController, PopoverController, LoadingController } from 'ionic-angular';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
/**
 * Generated class for the CoEventsMonthComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-month',
  templateUrl: 'co-events-month.html',
  inputs: ['currentDate']
})
export class CoEventsMonthComponent {
  @ViewChild(CoCalendarComponent) innerCalendar: CoCalendarComponent;
  todayEvents: Array<coEventsParameters>;
  searchTags: any;
  calendarLine: Array<string> = [];
  filteredWeek: any;
  monthEvents: any = [];
  currentDensity: any;
  density3Object: any;
  density3Array: any;
  allEvents: any;
  pageLoaded: boolean = false;
  clientKeyword: string;
  viewType: string;
  screenWidth: any = this.platform.width();
  aboveWidthBreakpoint: boolean;
  showKeywordBox: boolean = false;
  searchForKeyword: string = "";
  @Input('popOverFilter') popOverFilter: any;
  @Input('currentDate') currentDate;
  @Input('currentFilters') currentFilters;
  @Output() onNewDate: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  @Output() keywordSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('eventView') eventView;

  constructor(public eventsProvider: EventsProvider, public locationsProvider: LocationsProvider, public config: ConfigProvider, public navCtrl: NavController, private clientDetails: ClientDetailsProvider, public platform: Platform, public state: AppState, public modalCtrl: ModalController, public popoverCtrl: PopoverController, public filteringProvider: FilteringProvider, private loadingCtrl : LoadingController, private sounds : SoundsProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
      self.screenWidth = self.platform.width();
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    this.monthClicked(this.currentDate);

    const appRootIos = document.querySelector('.app-root-ios');
    if (appRootIos) {
      for(let x=0; x<10; x++){
        setTimeout(() => {
          appRootIos['style']['zIndex'] = appRootIos['style']['zIndex'] === '1' ? '2' : '1';
        }, x * 400);
      }
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  resetMonthView(date) {
    this.monthClicked(date);
  }

  updateKeywordFilter(){
    if (this.searchForKeyword.length > 0) this.keywordSearchEmit.emit({keyword: this.searchForKeyword})
  }

  cancelKeywordFilter(){
    this.keywordSearchEmit.emit({keyword: ''})
  }

  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId });
    });
  }

  updateBrochureStartDay(){
    this.eventQueryTimeArgs.emit({start: moment(this.currentDate).startOf('month').format("YYYY-MM-DD"), end: moment(this.currentDate).endOf('month').format("YYYY-MM-DD")});
  }

  calendarLoad(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).startOf('month').add(x, 'month').format("YYYY-MM-DD HH:mm:ss"))
    };
  };

  previousMonths(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  nextMonths(date: string) {
    let selectedDate = moment(date).startOf('month').add(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  monthClicked(dateString: string) {
    let startDate = moment(dateString).startOf('month').format("YYYY-MM-DD");
    let endDate = moment(dateString).endOf('month').format("YYYY-MM-DD");
    let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
    this.queryEventsMonth(newMonthQuery);
    this.innerCalendar.goToMonth(dateString);
    this.innerCalendar.loadMonthEvents(this.monthEvents);
    this.updateEvents(moment(dateString));
    this.calendarLoad(dateString);
    this.onNewDate.emit(dateString);
  }

  filterByPopOver(filterObj){
    this.filteringProvider.filterByPopover(filterObj, this.allEvents).then((res)=>{
      this.todayEvents = res;
      if (this.currentDensity === 3) this.createDensityThreeArray();
    })
  }

  queryEvents(args) {
    let loader = this.loadingCtrl.create({
      content:"Retrieving events..."
    });
    loader.present();
    this.eventsProvider.getEvents(args).then((res) => {
      this.updateBrochureStartDay();
      this.todayEvents = res.allEvents;
      this.allEvents = res.allEvents;
      this.searchTags = res.searchTypes;
      this.pageLoaded = true;


      this.filterByPopOver(this.popOverFilter);
      this.createDensityThreeArray();
      loader.dismiss().catch(err=>{});
    });
  }
  createDensityThreeArray(){
    this.density3Object = this.todayEvents.reduce((red, event) => {
      let currentEventTime = moment(event.eventStart).format("YYYY-DDD HH");
      if (!red[currentEventTime]) red[currentEventTime] = [];
      red[currentEventTime].push(event);
      return red;
    }, {});

    this.density3Array = Object.keys(this.density3Object).map((key) => {
      return this.density3Object[key];
    });
  }

  queryEventsMonth(args) {
    this.eventsProvider.getEvents(args).then((res) => {
      this.monthEvents = res.allEvents;
      this.searchTags = res.searchTypes;
      this.innerCalendar.loadMonthEvents(this.monthEvents);
    })
  }

  updateEvents(newDate: any) {
    this.onNewDate.emit(newDate);
    let startDate = moment(newDate).startOf('day').format("YYYY-MM-DD HH:mm:ss");
    let endDate = moment(newDate).endOf('day').format("YYYY-MM-DD HH:mm:ss");
    let eventsQueryArgs = `startDate: "${startDate}", endDate: "${endDate}"`;
    this.queryEvents(eventsQueryArgs);

  }

  updateDensity(density: number) {
    let className = "density" + density.toString();
    // let allEventViews = document.getElementsByClassName('eventView');
    let allEventViews = this.eventView.nativeElement;
    allEventViews.className = (className + " eventView");
    this.currentDensity = density;
  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-events-month/co-events-month.ts